import { ShipInfo } from '@ais-ui/websockets';
import { VesselResult } from '@ais-ui/api-spec/shipdb';

export const extractMmsiFromShipInfo = (shipInfo: ShipInfo | VesselResult) => {
  if ('mmsi' in shipInfo) {
    return parseInt(shipInfo.mmsi, 10);
  }

  if (shipInfo.basic && shipInfo.basic.vesselMmsiNumber) {
    return parseInt(shipInfo.basic.vesselMmsiNumber, 10);
  }

  return 0;
};
